import { styled } from '@mui/material/styles';
import Card from '@components/Card';
import { Typography } from '@components/Typography';
import UnverifiedBadge from '@components/UnverifiedBadge';
import { generateCompanyCardAddress } from '@helpers/companies';
import { BRAND_TEAL } from '@constants/colors';

const CardText = styled('p', {
    shouldForwardProp: prop => prop !== 'disabled',
})(({ disabled }) => ({
    fontFamily: 'Rubik, sans-serif',
    fontWeight: 500,
    fontSize: 10,
    lineHeight: '12px',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    color: 'var(--text-secondary)',
    marginTop: 0,
    ...(disabled && {
        color: 'var(--text-tertiary)',
    }),
}));

const GoogleLocationCard = ({ location = {}, selectedLocation, setLocation }) => {
    const isDisabled = location.connected;

    return (
        <Card
            type="radio"
            selected={
                location.locationId === selectedLocation.locationId &&
                location.integrationId === selectedLocation.integrationId &&
                !isDisabled
            }
            title={location.title}
            value={location.locationId}
            setValue={() => setLocation(location)}
            disabled={isDisabled}
        >
            {location.country && (
                <CardText disabled={isDisabled} style={{ marginBottom: '8px' }}>
                    {generateCompanyCardAddress(location)}
                </CardText>
            )}
            {location.primaryPhoneNumber && (
                <CardText disabled={isDisabled} style={{ marginBottom: 0 }}>
                    {location.primaryPhoneNumber}
                </CardText>
            )}
            {isDisabled && (
                <Typography
                    variant="caption"
                    sx={{
                        color: '#fff',
                        backgroundColor: BRAND_TEAL,
                        padding: '2px 6px',
                        borderRadius: '18px',
                        width: 'fit-content',
                        marginTop: '16px',
                    }}
                >
                    {location.connectedLocationName}
                </Typography>
            )}
            {!isDisabled && !location.isVerified && <UnverifiedBadge />}
        </Card>
    );
};

export default GoogleLocationCard;
